var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-collapse',_vm._g({class:['accordion-content', { 'is-shapeless': _vm.shapeless }],attrs:{"id":_vm.id,"accordion":_vm.accordion,"visible":_vm.visible,"role":"tabpanel"}},_vm.$listeners),[_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }